import { t } from "i18next";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useFetch } from "../../hooks/useFetch";
import { PersonById } from "../../types/types";
import { ScrollArea } from "../../ui/ScrollArea/ScrollArea";
import { Separator } from "../../ui/Separator";
import Spinner from "../../ui/Spinner/Spinner";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../ui/Tabs/Tabs";
import StaffAccessTab from "./tabs/staffAccessTab/StaffAccessTab";
import StaffMainTab from "./tabs/mainTab/StaffMainTab";
import { VerticalTabs, VerticalTabsContent, VerticalTabsList, VerticalTabsTrigger } from "../../ui/Tabs/VerticalTabs";
import StaffChangesTab from "./tabs/staffChangesTab/StaffChangesTab";
import { ReportTab } from "./tabs/reportTab/ReportTab";

const StaffItem = () => {
  const { id } = useParams();
  const [currentPerson, setCurrentPerson] = useState<PersonById>();
  const [loading, setLoading] = useState(true);
  const [{ response, isLoading, error }, doFetchItem] = useFetch(`/directories/personnels/${id}`);

  const updatePerson = () => {
    doFetchItem();
  };

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    doFetchItem();
  }, [id]);

  useEffect(() => {
    if (!response) return;
    setCurrentPerson(response.data as unknown as PersonById);
    setLoading(false);
  }, [response]);

  return loading ? (
    <Spinner />
  ) : (
    <>
      <Tabs defaultValue={currentPerson?.attributes.access_token_id ? "report" : "main"} className="flex flex-col bg-background relative h-full overflow-hidden">
        <TabsList className="flex-none justify-start px-6">
          { currentPerson?.attributes.access_token_id && <TabsTrigger className="data-[state=active]:bg-primary data-[state=active]:text-white" value="report">
            {t("report")}
          </TabsTrigger> }
          <TabsTrigger className="data-[state=active]:bg-primary data-[state=active]:text-white" value="main">
            {t("main_info")}
          </TabsTrigger>
          <TabsTrigger className="data-[state=active]:bg-primary data-[state=active]:text-white" value="access">
            {t("access_token_manage")}
          </TabsTrigger>
          <TabsTrigger className="data-[state=active]:bg-primary data-[state=active]:text-white" value="changelog">
            {t("changelog")}
          </TabsTrigger>
        </TabsList>
        <Separator/>
        <div className="flex flex-col w-full h-full justify-start relative overflow-hidden">
          <TabsContent className="flex flex-col w-full data-[state=active]:h-full m-0" value="report">
            <ReportTab person={currentPerson!}/>
          </TabsContent>
          <TabsContent className="flex flex-col max-w-[1008px] w-full data-[state=active]:h-full m-0"  value="main">
            {currentPerson ? (
              <StaffMainTab
                id={id}
                currentPerson={currentPerson}
                updatePerson={updatePerson}
                setCurrentPerson={setCurrentPerson}
              />
            ) : (
              ""
            )}
          </TabsContent>
          <TabsContent className="flex flex-col max-w-[1008px] w-full data-[state=active]:h-full m-0" value="access">
            <StaffAccessTab id={id} currentPerson={currentPerson} updatePerson={updatePerson} />
          </TabsContent>
          <TabsContent className="flex flex-col w-full data-[state=active]:h-full m-0" value="changelog">
            <StaffChangesTab id={id!}/>
          </TabsContent>
        </div>
      </Tabs>
      {/* <InfoTabs currentPerson={currentPerson!} /> */}
    </>
  );
};


export default StaffItem;
